import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

/**
 *  MÁS RENDSZEREK INTÉZMÉNYEI az intézményváltóban (backend/tobbintezmeny.js) – a profil-lenyílóban
 *  (Fókusz) és a bal sávban (Klasszikus). Választáskor a másik rendszer saját felülete nyílik meg.
 *  „Hozzáadás”: a másik rendszer címe (vagy a központi címtárból választva) → ott belépés és jóváhagyás.
 */
@Component({
  selector: 'app-tobb-intezmeny',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
  <div class="ti" [class.sotet]="sotet">
    <ng-container *ngFor="let k of kotesek">
      <button type="button" class="ti-int" *ngFor="let i of k.intezmenyek" (click)="nyit(k)" [title]="'Megnyitás: ' + k.tars_url">
        <span>↗ {{ i.nev }}</span><small>{{ k.tars_nev || k.tars_url }}</small>
      </button>
    </ng-container>
    <button type="button" class="ti-link" *ngIf="!urlap" (click)="urlapNyit()">+ Intézmény hozzáadása másik rendszerből</button>
    <div class="ti-urlap" *ngIf="urlap">
      <select *ngIf="cimtar.length" [(ngModel)]="cel"><option value="">— válassz a címtárból —</option><option *ngFor="let c of cimtar" [value]="c.url">{{ c.nev }}</option></select>
      <input [(ngModel)]="cel" placeholder="a másik rendszer címe, pl. https://erp.iskola.hu">
      <div class="ti-gombok"><button type="button" (click)="indit()" [disabled]="!cel">Tovább a belépéshez</button><button type="button" class="ti-link" (click)="urlap = false">mégse</button></div>
      <small>A másik rendszerben a saját ottani fiókoddal lépsz be; csak akkor adható hozzá, ha ott is van jogosultságod.</small>
    </div>
    <small class="ti-hiba" *ngIf="hiba">{{ hiba }}</small>
    <ng-container *ngIf="kezel && kotesek.length">
      <button type="button" class="ti-link" *ngFor="let k of kotesek" (click)="torol(k)">× {{ k.tars_nev || k.tars_url }} eltávolítása</button>
    </ng-container>
  </div>`,
  styles: [`
    .ti { display: grid; gap: 4px; font-size: 12.5px; }
    .ti-int { display: grid; text-align: left; border: 0; background: transparent; padding: 5px 8px; border-radius: 6px; cursor: pointer; color: inherit; font: inherit;
      small { opacity: .65; font-size: 11px; } &:hover { background: rgba(127,127,127,.12); } }
    .ti-link { border: 0; background: none; color: #0f766e; cursor: pointer; text-align: left; padding: 3px 8px; font: inherit; font-size: 12px; }
    .sotet .ti-link { color: #99f6e4; }
    .ti-urlap { display: grid; gap: 6px; padding: 4px 8px;
      input, select { font: inherit; padding: 5px 7px; border: 1px solid #d0d5dd; border-radius: 6px; }
      small { opacity: .7; font-size: 11px; } }
    .ti-gombok { display: flex; gap: 8px; align-items: center;
      button:first-child { border: 0; border-radius: 6px; padding: 5px 10px; background: #0f766e; color: #fff; cursor: pointer; font-weight: 600; } }
    .ti-hiba { color: #f04438; padding: 0 8px; }
  `],
})
export class TobbIntezmenyComponent implements OnInit {
  @Input() sotet = false;
  /** Eltávolítás gombok (a profil-lenyílóban). */
  @Input() kezel = false;
  kotesek: any[] = [];
  cimtar: any[] = [];
  urlap = false;
  cel = '';
  hiba = '';

  constructor(private http: HttpClient) {}

  async ngOnInit() { try { this.kotesek = await firstValueFrom(this.http.get<any[]>('/api/tobbintezmeny/lista')); } catch { this.kotesek = []; } }
  async urlapNyit() {
    this.urlap = true; this.hiba = '';
    try { this.cimtar = (await firstValueFrom(this.http.get<any[]>('/api/tobbintezmeny/cimtar'))).filter((c) => c.url !== window.location.origin); } catch { this.cimtar = []; }
  }
  async indit() {
    this.hiba = '';
    try {
      const r: any = await firstValueFrom(this.http.post('/api/tobbintezmeny/inditas', { cel: this.cel.trim(), sajat: window.location.origin }));
      window.location.href = r.atiranyitas;
    } catch (e: any) { this.hiba = e?.error?.error || 'Nem sikerült elindítani.'; }
  }
  nyit(k: any) { window.location.href = k.tars_url; }
  async torol(k: any) {
    try { await firstValueFrom(this.http.delete(`/api/tobbintezmeny/${k.id}`)); await this.ngOnInit(); } catch (e: any) { this.hiba = e?.error?.error || 'Nem sikerült.'; }
  }
}
